import { useTranslation as useTranslationOriginal } from "next-i18next"

export type TranslateFunction = (
    label: string,
    options?: Record<string, number | Namespace>
) => string
type Namespace = string | string[] | readonly string[] | undefined

export const useTranslation = (ns?: Namespace) => {
    const tools = useTranslationOriginal(ns)
    const { t } = tools

    return {
        ...tools,
        t: t as TranslateFunction,
    }
}
